import { ITicketGroup } from 'meta/backendControlled/structure/ticket'
import { FormFieldType } from 'meta/form'
import { getUniqueTypeTicketsIds } from 'helpers/groups/unique'

import { ITicket, ITicketCovidAppointment, ITicketExtraField } from './types'

export class TicketAdapter {
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  static convertResponse(items: Array<any>, groups: Array<ITicketGroup>): Array<ITicket> {
    /* eslint-disable  @typescript-eslint/no-explicit-any */
    return items?.reduce<Array<ITicket>>((tickets, ticketResp: any) => {
      const alreadyFetchedGroupsIds: number[] = []
      const uniqueGroupIds = getUniqueTypeTicketsIds(groups)

      let previousTicketId
      let currentGroupPosition = 1

      for (let i = 0; i < ticketResp.quantity; i++) {
        const ticket = this.convertTicket(ticketResp)

        let isFirstOfGroup = false

        if (
          ticketResp?.ticket?.id &&
          uniqueGroupIds.includes(ticketResp?.ticket?.id) &&
          !alreadyFetchedGroupsIds.includes(ticketResp?.ticket?.id)
        ) {
          isFirstOfGroup = true
          alreadyFetchedGroupsIds.push(ticketResp?.ticket?.id)
        }

        ticket.isFirstOfGroup = isFirstOfGroup
        ticket.isPartOfGroup = uniqueGroupIds.includes(ticketResp?.ticket?.id)

        if (previousTicketId != ticketResp?.ticket?.id) {
          previousTicketId = ticketResp?.ticket?.id
          currentGroupPosition = 1
        } else {
          currentGroupPosition += 1
        }

        ticket.positionInGroup = currentGroupPosition

        tickets.push(ticket)
      }

      return tickets
    }, [])
  }
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  private static convertTicket(ticketResp: any): ITicket {
    const ticket: ITicket = {
      details: ticketResp.ticket.webDetails,
      extraFields: ticketResp.additionalInfo.map(this.convertExtraField),
      appointments: ticketResp.appointments ? ticketResp.appointments.map(this.convertAppointment) : null,
      id: ticketResp.ticket.id,
      seatId: ticketResp?.seatId,
      title: ticketResp?.sectorName
        ? `${ticketResp?.sectorName} - ${ticketResp.ticket.notes}`
        : ticketResp.ticket.notes,
      typeTicketId: ticketResp.ticket.typeTicket,
      groupQty: ticketResp.quantity,
    }
    return ticket
  }

  //@ts-ignore
  private static convertAppointment(info): ITicketCovidAppointment {
    const appointment: ITicketCovidAppointment = {
      uuid: info.uuid,
      name: info.name,
      status: info.status,
      //@ts-ignore
      appointmentSlots: info.appointmentSlots.map((slot) => {
        return {
          uuid: slot.uuid,
          from: new Date(slot.from_tz),
          status: slot.status,
        }
      }),
    }

    return appointment
  }

  //@ts-ignore
  private static convertExtraField(info): ITicketExtraField {
    const extraField: ITicketExtraField = {
      dataType: info.dataType,
      fieldType: info.fieldType === 0 ? FormFieldType.text : FormFieldType.select,
      id: info.id,
      label: info.fieldName,
      metadata: info.metadata,
      name: info.fieldName.replace(/[^0-9a-z]/gi, ''),
      placeholder: info.fieldDescription,
      required: info.isRequired,
    }
    if (extraField.fieldType === FormFieldType.select) {
      const fieldValues = Array.isArray(info.fieldValues) ? info.fieldValues : JSON.parse(info.fieldValues)
      //@ts-ignore
      extraField.options = fieldValues.map((value) => ({ value, label: value }))
    }

    return extraField
  }
}
